export const rcpaPricingVersions = [['rcpa-1.0-2025-01-16', { label: 'Version 1' }]] as const

export type RcpaPricingVersion = (typeof rcpaPricingVersions)[number][0]
